// GENERADO por data/pipeline/catalogo_comunas.py. No editar a mano: corre `make catalogo`.
//
// Catálogo de regiones y comunas de Chile con la grafía EXACTA de la columna COMUNA
// del export de Smallworld (mayúsculas, sin tildes). En el formulario solo se ofrecen
// las comunas que además están publicadas en public/datos_metadata.json.

export interface RegionConfig {
  id: string;
  nombre: string;
  comunas: string[];
}

// Ordenadas de norte a sur.
export const REGIONES: RegionConfig[] = [
  {
    id: 'Arica y Parinacota',
    nombre: 'Región de Arica y Parinacota',
    comunas: [
      'ARICA',
      'CAMARONES',
      'PUTRE',
      'GENERAL LAGOS',
    ]
  },
  {
    id: 'Tarapacá',
    nombre: 'Región de Tarapacá',
    comunas: [
      'IQUIQUE',
      'ALTO HOSPICIO',
      'POZO ALMONTE',
      'CAMINA',
      'COLCHANE',
      'HUARA',
      'PICA',
    ]
  },
  {
    id: 'Antofagasta',
    nombre: 'Región de Antofagasta',
    comunas: [
      'ANTOFAGASTA',
      'MEJILLONES',
      'SIERRA GORDA',
      'TALTAL',
      'CALAMA',
      'OLLAGUE',
      'SAN PEDRO DE ATACAMA',
      'TOCOPILLA',
      'MARIA ELENA',
    ]
  },
  {
    id: 'Atacama',
    nombre: 'Región de Atacama',
    comunas: [
      'COPIAPO',
      'CALDERA',
      'TIERRA AMARILLA',
      'CHANARAL',
      'DIEGO DE ALMAGRO',
      'VALLENAR',
      'ALTO DEL CARMEN',
      'FREIRINA',
      'HUASCO',
    ]
  },
  {
    id: 'Coquimbo',
    nombre: 'Región de Coquimbo',
    comunas: [
      'LA SERENA',
      'COQUIMBO',
      'ANDACOLLO',
      'LA HIGUERA',
      'PAIHUANO',
      'VICUNA',
      'ILLAPEL',
      'CANELA',
      'LOS VILOS',
      'SALAMANCA',
      'OVALLE',
      'COMBARBALA',
      'MONTE PATRIA',
      'PUNITAQUI',
      'RIO HURTADO',
    ]
  },
  {
    id: 'Valparaíso',
    nombre: 'Región de Valparaíso',
    comunas: [
      'VALPARAISO',
      'CASABLANCA',
      'CONCON',
      'JUAN FERNANDEZ',
      'PUCHUNCAVI',
      'QUINTERO',
      'VINA DEL MAR',
      'ISLA DE PASCUA',
      'LOS ANDES',
      'CALLE LARGA',
      'RINCONADA',
      'SAN ESTEBAN',
      'LA LIGUA',
      'CABILDO',
      'PAPUDO',
      'PETORCA',
      'ZAPALLAR',
      'QUILLOTA',
      'CALERA',
      'HIJUELAS',
      'LA CRUZ',
      'NOGALES',
      'SAN ANTONIO',
      'ALGARROBO',
      'CARTAGENA',
      'EL QUISCO',
      'EL TABO',
      'SANTO DOMINGO',
      'SAN FELIPE',
      'CATEMU',
      'LLAILLAY',
      'PANQUEHUE',
      'PUTAENDO',
      'SANTA MARIA',
      'QUILPUE',
      'LIMACHE',
      'OLMUE',
      'VILLA ALEMANA',
    ]
  },
  {
    id: 'Metropolitana',
    nombre: 'Región Metropolitana',
    comunas: [
      'SANTIAGO',
      'CERRILLOS',
      'CERRO NAVIA',
      'CONCHALI',
      'EL BOSQUE',
      'ESTACION CENTRAL',
      'HUECHURABA',
      'INDEPENDENCIA',
      'LA CISTERNA',
      'LA FLORIDA',
      'LA GRANJA',
      'LA PINTANA',
      'LA REINA',
      'LAS CONDES',
      'LO BARNECHEA',
      'LO ESPEJO',
      'LO PRADO',
      'MACUL',
      'MAIPU',
      'NUNOA',
      'PEDRO AGUIRRE CERDA',
      'PENALOLEN',
      'PROVIDENCIA',
      'PUDAHUEL',
      'QUILICURA',
      'QUINTA NORMAL',
      'RECOLETA',
      'RENCA',
      'SAN JOAQUIN',
      'SAN MIGUEL',
      'SAN RAMON',
      'VITACURA',
      'PUENTE ALTO',
      'PIRQUE',
      'SAN JOSE DE MAIPO',
      'COLINA',
      'LAMPA',
      'TILTIL',
      'SAN BERNARDO',
      'BUIN',
      'CALERA DE TANGO',
      'PAINE',
      'MELIPILLA',
      'ALHUE',
      'CURACAVI',
      'MARIA PINTO',
      'SAN PEDRO',
      'TALAGANTE',
      'EL MONTE',
      'ISLA DE MAIPO',
      'PADRE HURTADO',
      'PENAFLOR',
    ]
  },
  {
    id: 'O\'Higgins',
    nombre: 'Región de O\'Higgins',
    comunas: [
      'RANCAGUA',
      'CODEGUA',
      'COINCO',
      'COLTAUCO',
      'DONIHUE',
      'GRANEROS',
      'LAS CABRAS',
      'MACHALI',
      'MALLOA',
      'MOSTAZAL',
      'OLIVAR',
      'PEUMO',
      'PICHIDEGUA',
      'QUINTA DE TILCOCO',
      'RENGO',
      'REQUINOA',
      'SAN VICENTE',
      'PICHILEMU',
      'LA ESTRELLA',
      'LITUECHE',
      'MARCHIHUE',
      'NAVIDAD',
      'PAREDONES',
      'SAN FERNANDO',
      'CHEPICA',
      'CHIMBARONGO',
      'LOLOL',
      'NANCAGUA',
      'PALMILLA',
      'PERALILLO',
      'PLACILLA',
      'PUMANQUE',
      'SANTA CRUZ',
    ]
  },
  {
    id: 'Maule',
    nombre: 'Región del Maule',
    comunas: [
      'TALCA',
      'CONSTITUCION',
      'CUREPTO',
      'EMPEDRADO',
      'MAULE',
      'PELARCO',
      'PENCAHUE',
      'RIO CLARO',
      'SAN CLEMENTE',
      'SAN RAFAEL',
      'CAUQUENES',
      'CHANCO',
      'PELLUHUE',
      'CURICO',
      'HUALANE',
      'LICANTEN',
      'MOLINA',
      'RAUCO',
      'ROMERAL',
      'SAGRADA FAMILIA',
      'TENO',
      'VICHUQUEN',
      'LINARES',
      'COLBUN',
      'LONGAVI',
      'PARRAL',
      'RETIRO',
      'SAN JAVIER',
      'VILLA ALEGRE',
      'YERBAS BUENAS',
    ]
  },
  {
    id: 'Ñuble',
    nombre: 'Región de Ñuble',
    comunas: [
      'CHILLAN',
      'BULNES',
      'CHILLAN VIEJO',
      'EL CARMEN',
      'PEMUCO',
      'PINTO',
      'QUILLON',
      'SAN IGNACIO',
      'YUNGAY',
      'QUIRIHUE',
      'COBQUECURA',
      'COELEMU',
      'NINHUE',
      'PORTEZUELO',
      'RANQUIL',
      'TREGUACO',
      'SAN CARLOS',
      'COIHUECO',
      'NIQUEN',
      'SAN FABIAN',
      'SAN NICOLAS',
    ]
  },
  {
    id: 'Biobío',
    nombre: 'Región del Biobío',
    comunas: [
      'CONCEPCION',
      'CORONEL',
      'CHIGUAYANTE',
      'FLORIDA',
      'HUALQUI',
      'LOTA',
      'PENCO',
      'SAN PEDRO DE LA PAZ',
      'SANTA JUANA',
      'TALCAHUANO',
      'TOME',
      'HUALPEN',
      'LEBU',
      'ARAUCO',
      'CANETE',
      'CONTULMO',
      'CURANILAHUE',
      'LOS ALAMOS',
      'TIRUA',
      'LOS ANGELES',
      'ANTUCO',
      'CABRERO',
      'LAJA',
      'MULCHEN',
      'NACIMIENTO',
      'NEGRETE',
      'QUILACO',
      'QUILLECO',
      'SAN ROSENDO',
      'SANTA BARBARA',
      'TUCAPEL',
      'YUMBEL',
      'ALTO BIOBIO',
    ]
  },
  {
    id: 'La Araucanía',
    nombre: 'Región de La Araucanía',
    comunas: [
      'TEMUCO',
      'CARAHUE',
      'CUNCO',
      'CURARREHUE',
      'FREIRE',
      'GALVARINO',
      'GORBEA',
      'LAUTARO',
      'LONCOCHE',
      'MELIPEUCO',
      'NUEVA IMPERIAL',
      'PADRE LAS CASAS',
      'PERQUENCO',
      'PITRUFQUEN',
      'PUCON',
      'SAAVEDRA',
      'TEODORO SCHMIDT',
      'TOLTEN',
      'VILCUN',
      'VILLARRICA',
      'CHOL CHOL',
      'ANGOL',
      'COLLIPULLI',
      'CURACAUTIN',
      'ERCILLA',
      'LONQUIMAY',
      'LOS SAUCES',
      'LUMACO',
      'PUREN',
      'RENAICO',
      'TRAIGUEN',
      'VICTORIA',
    ]
  },
  {
    id: 'Los Ríos',
    nombre: 'Región de Los Ríos',
    comunas: [
      'VALDIVIA',
      'CORRAL',
      'LANCO',
      'LOS LAGOS',
      'MAFIL',
      'MARIQUINA',
      'PAILLACO',
      'PANGUIPULLI',
      'LA UNION',
      'FUTRONO',
      'LAGO RANCO',
      'RIO BUENO',
    ]
  },
  {
    id: 'Los Lagos',
    nombre: 'Región de Los Lagos',
    comunas: [
      'PUERTO MONTT',
      'CALBUCO',
      'COCHAMO',
      'FRESIA',
      'FRUTILLAR',
      'LOS MUERMOS',
      'LLANQUIHUE',
      'MAULLIN',
      'PUERTO VARAS',
      'CASTRO',
      'ANCUD',
      'CHONCHI',
      'CURACO DE VELEZ',
      'DALCAHUE',
      'PUQUELDON',
      'QUEILEN',
      'QUELLON',
      'QUEMCHI',
      'QUINCHAO',
      'OSORNO',
      'PUERTO OCTAY',
      'PURRANQUE',
      'PUYEHUE',
      'RIO NEGRO',
      'SAN JUAN DE LA COSTA',
      'SAN PABLO',
      'CHAITEN',
      'FUTALEUFU',
      'HUALAIHUE',
      'PALENA',
    ]
  },
  {
    id: 'Aysén',
    nombre: 'Región de Aysén',
    comunas: [
      'COIHAIQUE',
      'LAGO VERDE',
      'AISEN',
      'CISNES',
      'GUAITECAS',
      'COCHRANE',
      'O\'HIGGINS',
      'TORTEL',
      'CHILE CHICO',
      'RIO IBANEZ',
    ]
  },
  {
    id: 'Magallanes',
    nombre: 'Región de Magallanes',
    comunas: [
      'PUNTA ARENAS',
      'LAGUNA BLANCA',
      'RIO VERDE',
      'SAN GREGORIO',
      'CABO DE HORNOS',
      'ANTARTICA',
      'PORVENIR',
      'PRIMAVERA',
      'TIMAUKEL',
      'NATALES',
      'TORRES DEL PAINE',
    ]
  },
];

// Solo las comunas cuyo nombre visible no se obtiene con un simple Title Case.
const DISPLAY_NAMES: Record<string, string> = {
  'CAMINA': 'Camiña',
  'OLLAGUE': 'Ollagüe',
  'SAN PEDRO DE ATACAMA': 'San Pedro de Atacama',
  'MARIA ELENA': 'María Elena',
  'COPIAPO': 'Copiapó',
  'CHANARAL': 'Chañaral',
  'DIEGO DE ALMAGRO': 'Diego de Almagro',
  'ALTO DEL CARMEN': 'Alto del Carmen',
  'VICUNA': 'Vicuña',
  'COMBARBALA': 'Combarbalá',
  'RIO HURTADO': 'Río Hurtado',
  'VALPARAISO': 'Valparaíso',
  'CONCON': 'Concón',
  'JUAN FERNANDEZ': 'Juan Fernández',
  'VINA DEL MAR': 'Viña del Mar',
  'ISLA DE PASCUA': 'Isla de Pascua',
  'LLAILLAY': 'Llay-Llay',
  'CALERA': 'La Calera',
  'OLMUE': 'Olmué',
  'QUILPUE': 'Quilpué',
  'SANTA MARIA': 'Santa María',
  'PUCHUNCAVI': 'Puchuncaví',
  'CONCHALI': 'Conchalí',
  'ESTACION CENTRAL': 'Estación Central',
  'MAIPU': 'Maipú',
  'NUNOA': 'Ñuñoa',
  'PENALOLEN': 'Peñalolén',
  'SAN JOAQUIN': 'San Joaquín',
  'SAN RAMON': 'San Ramón',
  'SAN JOSE DE MAIPO': 'San José de Maipo',
  'ALHUE': 'Alhué',
  'CURACAVI': 'Curacaví',
  'MARIA PINTO': 'María Pinto',
  'ISLA DE MAIPO': 'Isla de Maipo',
  'PENAFLOR': 'Peñaflor',
  'CALERA DE TANGO': 'Calera de Tango',
  'DONIHUE': 'Doñihue',
  'MACHALI': 'Machalí',
  'REQUINOA': 'Requínoa',
  'QUINTA DE TILCOCO': 'Quinta de Tilcoco',
  'MARCHIHUE': 'Marchigüe',
  'CHEPICA': 'Chépica',
  'CONSTITUCION': 'Constitución',
  'RIO CLARO': 'Río Claro',
  'CURICO': 'Curicó',
  'HUALANE': 'Hualañé',
  'LICANTEN': 'Licantén',
  'VICHUQUEN': 'Vichuquén',
  'COLBUN': 'Colbún',
  'LONGAVI': 'Longaví',
  'CHILLAN': 'Chillán',
  'CHILLAN VIEJO': 'Chillán Viejo',
  'QUILLON': 'Quillón',
  'RANQUIL': 'Ránquil',
  'TREGUACO': 'Trehuaco',
  'NIQUEN': 'Ñiquén',
  'SAN FABIAN': 'San Fabián',
  'SAN NICOLAS': 'San Nicolás',
  'CONCEPCION': 'Concepción',
  'HUALPEN': 'Hualpén',
  'TOME': 'Tomé',
  'CANETE': 'Cañete',
  'LOS ALAMOS': 'Los Álamos',
  'TIRUA': 'Tirúa',
  'LOS ANGELES': 'Los Ángeles',
  'MULCHEN': 'Mulchén',
  'SANTA BARBARA': 'Santa Bárbara',
  'ALTO BIOBIO': 'Alto Biobío',
  'SAN PEDRO DE LA PAZ': 'San Pedro de la Paz',
  'CURACAUTIN': 'Curacautín',
  'PUCON': 'Pucón',
  'PITRUFQUEN': 'Pitrufquén',
  'TOLTEN': 'Toltén',
  'VILCUN': 'Vilcún',
  'PUREN': 'Purén',
  'TRAIGUEN': 'Traiguén',
  'CHOL CHOL': 'Cholchol',
  'LA UNION': 'La Unión',
  'MAFIL': 'Máfil',
  'RIO BUENO': 'Río Bueno',
  'COCHAMO': 'Cochamó',
  'MAULLIN': 'Maullín',
  'CURACO DE VELEZ': 'Curaco de Vélez',
  'PUQUELDON': 'Puqueldón',
  'QUELLON': 'Quellón',
  'QUEILEN': 'Queilén',
  'RIO NEGRO': 'Río Negro',
  'SAN JUAN DE LA COSTA': 'San Juan de la Costa',
  'CHAITEN': 'Chaitén',
  'FUTALEUFU': 'Futaleufú',
  'HUALAIHUE': 'Hualaihué',
  'COIHAIQUE': 'Coyhaique',
  'AISEN': 'Aysén',
  'O\'HIGGINS': 'O\'Higgins',
  'RIO IBANEZ': 'Río Ibáñez',
  'CABO DE HORNOS': 'Cabo de Hornos',
  'ANTARTICA': 'Antártica',
  'TORRES DEL PAINE': 'Torres del Paine',
  'RIO VERDE': 'Río Verde',
};

const toTitleCase = (value: string): string =>
  value.toLowerCase().replace(/(^|\s)\S/g, match => match.toUpperCase());

export const comunaDisplayName = (comuna: string): string =>
  DISPLAY_NAMES[comuna] || toTitleCase(comuna);
